export function trackUnfavoriteStation(station) {
  const { name, collectionTitle } = station;
  window.Taq.push([
    'track',
    'link',
    {
      ...window.Taq.jukeCustomData,
      event_name: 'content-interactions_remove-my-category',
      event_category: 'content-interactions',
      event_action: 'remove-my-category',
      event_label: collectionTitle || name || null,
      player_channel: name || null,
      c_media_music_type: 'station',
      content_id: collectionTitle || null,
    },
  ]);
}

export function trackFavoriteStation(station) {
  const { name, collectionTitle } = station;
  window.Taq.push([
    'track',
    'link',
    {
      ...window.Taq.jukeCustomData,
      event_name: 'content-interactions_add-my-category',
      event_category: 'content-interactions',
      event_action: 'add-my-category',
      event_label: collectionTitle || name || null,
      player_channel: name || null,
      c_media_music_type: 'station',
      content_id: collectionTitle || null,
    },
  ]);
}

export function trackFavoritePodcast(podcast) {
  const { title, isPodcast, listItem, collectionTitle } = podcast;
  if (isPodcast && listItem) {
    return window.Taq.push([
      'track',
      'link',
      {
        event_name: collectionTitle || 'content-interactions_add-my-category',
        event_category: 'content-listing',
        event_action: 'favorite',
        event_label: title || null,
        player_channel: title || null,
        media_name: title || null,
        media_program_name: collectionTitle || null,
        c_media_music_type: 'podcast',
      },
    ]);
  }
  return window.Taq.push([
    'track',
    'link',
    {
      event_name: collectionTitle || 'content-interactions_add-my-category',
      event_category: collectionTitle ? 'content-listing' : 'content-interactions',
      event_action: collectionTitle ? 'favorite' : 'add-my-category',
      event_label: collectionTitle || title || null,
      player_channel: title || null,
      c_media_music_type: 'podcast',
    },
  ]);
}

export function trackUnfavoritePodcast(podcast) {
  const { title, isPodcast, listItem, collectionTitle } = podcast;
  if (isPodcast && listItem) {
    return window.Taq.push([
      'track',
      'link',
      {
        event_name: collectionTitle || 'content-interactions_remove-my-category',
        event_category: 'content-listing',
        event_action: 'unfavorite',
        event_label: title || null,
        player_channel: title || null,
        media_name: title || null,
        media_program_name: collectionTitle || null,
        c_media_music_type: 'podcast',
      },
    ]);
  }
  return window.Taq.push([
    'track',
    'link',
    {
      event_name: collectionTitle || 'content-interactions_remove-my-category',
      event_category: collectionTitle ? 'content-listing' : 'content-interactions',
      event_action: collectionTitle ? 'unfavorite' : 'remove-my-category',
      event_label: collectionTitle || title || null,
      player_channel: title || null,
      c_media_music_type: 'podcast',
    },
  ]);
}
export function trackFavoriteClip(clip) {
  const { title, isPodcastEpisodePage, isClip, listItem, collectionTitle, podcast } = clip;
  if (isClip && listItem) {
    return window.Taq.push([
      'track',
      'link',
      {
        event_name: 'content-interactions_add-my-category',
        event_category: 'content-listing',
        event_action: 'favorite',
        event_label: title || null,
        player_channel: title || null,
        media_name: title || null,
        media_program_name: collectionTitle || podcast?.collectionTitle || null,
        c_media_music_type: 'podcast-episode',
      },
    ]);
  }

  return window.Taq.push([
    'track',
    'link',
    {
      event_name: 'content-interactions_add-my-category',
      event_category: isPodcastEpisodePage ? 'content_listening' : 'content-interactions',
      event_action: isPodcastEpisodePage ? 'add_to_favorite' : 'add-my-category',
      event_label: title || null,
      player_channel: title || null,
      c_media_music_type: 'podcast-episode',
    },
  ]);
}

export function trackUnfavoriteClip(clip) {
  const { title, isPodcastEpisodePage, isClip, listItem, collectionTitle, podcast } = clip;
  if (isClip && listItem) {
    return window.Taq.push([
      'track',
      'link',
      {
        event_name: 'content-interactions_remove-my-category',
        event_category: 'content-listing',
        event_action: 'unfavorite',
        event_label: title || null,
        player_channel: title || null,
        media_name: title || null,
        media_program_name: collectionTitle || podcast?.collectionTitle || null,
        c_media_music_type: 'podcast-episode',
      },
    ]);
  }
  return window.Taq.push([
    'track',
    'link',
    {
      event_name: 'content-interactions_remove-my-category',
      event_category: isPodcastEpisodePage ? 'content_listing' : 'content-interactions',
      event_action: isPodcastEpisodePage ? 'remove_from_favorite' : 'remove-my-category',
      event_label: title || null,
      player_channel: title || null,
      c_media_music_type: 'podcast-episode',
    },
  ]);
}

export function trackFavoriteTrack(track, station) {
  const trackId = track ? `${track.isrc} - ${track.artist} - ${track.title}` : null;
  const { name } = station;
  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'juke-player_add-my-category',
      event_category: 'juke-player',
      event_action: 'add-my-category',
      event_label: trackId,
      player_channel: name || null,
      c_media_music_type: 'track',
      c_media_music_trackname: trackId,
    },
  ]);
}

export function trackUnfavoriteTrack(track, station) {
  const trackId = track ? `${track.isrc} - ${track.artist} - ${track.title}` : null;
  const { name } = station;
  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'juke-player_remove-my-category',
      event_category: 'juke-player',
      event_action: 'remove-my-category',
      event_label: trackId,
      player_channel: name || null,
      c_media_music_type: 'track',
      c_media_music_trackname: trackId,
    },
  ]);
}
